import React from 'react';
import './loading.css'

const Loading = ({ text }) => {
    return (
        <div className="loading__container fade-in">
          <div className="loading__spinner"></div>
          <p className="loading__text">Cargando {text}...</p>
        </div>
    );
};

export default Loading;
